import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
//primeReact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Panel from "../../../components/panel/panel";
import CalendarInput from "../../../components/input/CalendarInput";

const IbCash = () => {
  const form = useForm();
  const errors = form.formState.errors;
  const navigate = useNavigate();

  const items = [
    {
      template: () => (
        <Link to={"/wallet/dashboard"} className="p-breadcrumb-link">
          IB CASH | Cashback
        </Link>
      ),
    },
  ];
  const home = {
    icon: "fa fa-home",
  };

  const extract = [
    {
      id: 1,
      dataCash: "12/12/2023",
      coefficientPercentage: 20,
      balanceConsidered: 250,
      totalCash: 350,
      balanceCash: 550,
      description: "Cashback dia 12/12",
      status: "recebido",
      dayLoot: "15/12/2023",
      valueLoot: 550,
    },
  ];

  const columns = [
    { field: "id", header: "Código" },
    { field: "dataCash", header: "Data Cash" },
    { field: "coefficientPercentage", header: "Coeficiente Percentual" },
    { field: "balanceConsidered", header: "Saldo Considerado" },
    { field: "totalCash", header: "Total Cash Aplicado" },
    { field: "balanceCash", header: "Saldo Cash" },
    { field: "description", header: "Descrição" },
    { field: "status", header: "status" },
    { field: "dayLoot", header: "Cotação no Dia do Saque" },
    { field: "valueLoot", header: "Valor Convertido no Saque" },
  ];

  const onSubmit = (data) => {
//    console.log(data);
    form.reset();
  };

  return (
    <>
      <div className="d-flex justify-content-between">
        <div>
          <BreadCrumb
            model={items}
            home={home}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "16px",
            }}
          />
        </div>
        <Button
          rounded
          label="Solicitar Saque"
          onClick={() => navigate(`shop`)}
          className="p-inputtext-sm px-4"
        />
      </div>
      <div className="row">
        <div className="col-md-4 my-2">
          <Panel>
            <div className="d-flex justify-content-between">
              <small className="bg-success rounded-pill text-white p-2">
                Saldo Ib Cash
              </small>
            </div>
            <div className="py-3 d-flex mx-4">
              <div>
                <span className="text-gray">Saldo disponível</span>
                <h1>IBC 16.7</h1>
              </div>
              <h1
                className="ms-5 mb-4"
                style={{ scale: "1.6", position: "absolute", right: "50px" }}
              >
                <i className="fa-solid fa-sack-dollar fa-2xl text-success text-opacity-25"></i>
              </h1>
            </div>
          </Panel>
        </div>
        <div className="col-md-4 my-2">
          <Panel>
            <div className="d-flex justify-content-between">
              <small className="bg-success rounded-pill text-white p-2">
                Saldo em R$
              </small>
            </div>
            <div className="py-3 d-flex mx-4">
              <div>
                <span className="text-gray">Saldo disponível</span>
                <h1>R$ 49,32</h1>
              </div>
              <h1
                className="ms-5 mb-4"
                style={{ scale: "1.6", position: "absolute", right: "50px" }}
              >
                <i className="fa-solid fa-money-bill-1 fa-2xl text-success text-opacity-25"></i>
              </h1>
            </div>
          </Panel>
        </div>
        <div className="col-md-4 my-2">
          <Panel>
            <div className="d-flex justify-content-between">
              <small className="bg-success rounded-pill text-white p-2">
                Cotação do dia
              </small>
            </div>
            <div className="py-3 d-flex mx-4">
              <div>
                <span className="text-gray">Cotação do dia (IBC/R$)</span>
                <h1>0.75%</h1>
              </div>
              <h1
                className="ms-5 mb-4"
                style={{ scale: "1.6", position: "absolute", right: "50px" }}
              >
                <i className="fa-solid fa-money-bill-trend-up fa-2xl text-success text-opacity-25"></i>
              </h1>
            </div>
          </Panel>
        </div>
      </div>
      <div className="mt-3">
        <Panel>
          <h4>Extrato por Período</h4>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-md-4">
                <CalendarInput
                  name="dateFirst"
                  control={form.control}
                  errors={errors}
                  label={`Data Inicial`}
                />
              </div>
              <div className="col-md-4">
                <CalendarInput
                  name="dateEnd"
                  control={form.control}
                  errors={errors}
                  label={`Data Final`}
                />
              </div>
              <div className="col-md-4 pt-3">
                <Button
                  rounded
                  type="submit"
                  iconPos="left"
                  label="Consultar"
                  icon="fa-solid fa-magnifying-glass"
                  className="p-inputtext-sm m-auto w-100"
                />
              </div>
            </div>
          </form>
        </Panel>
      </div>
      <div className="row mt-4">
        <Panel>
          <h4>Extrato</h4>
          <DataTable
            rows={5}
            paginator
            stripedRows
            showGridlines
            sortMode="multiple"
            selectionMode="single"
            rowsPerPageOptions={[5, 25, 100]}
            value={extract}
            emptyMessage="Nenhuma Informação foi encontrada."
            tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
          >
            {columns.map((col) => (
              <Column
                sortable
                key={col.field}
                field={col.field}
                header={col.header}
              />
            ))}
          </DataTable>
        </Panel>
      </div>
    </>
  );
};

export default IbCash;
